// Updated credits based on Commencement 2025 PDF
export const credits = {
  "Corporate Board": [
    { staff_name: "Shea Vance", title: "Editor in Chief" },
    { staff_name: "Heather Chen", title: "Managing Editor" },
    { staff_name: "Albert Tsai", title: "Publisher" }
  ],
  "Engineering": [
    { staff_name: "Noel Negron", title: "Head of Engineering" },
    { staff_name: "Aishani Srikumar", title: "Engineering Manager" },
    { staff_name: "Zara Khan", title: "Engineering Manager" },
    { staff_name: "Julien Remy", title: "Engineering Manager" },
    { staff_name: "Annie Dong", title: "Senior Engineering Developer" }
  ],
  "Product": [
    { staff_name: "Daniela Velazquez", title: "Head of Product" },
    { staff_name: "Melinda Yao", title: "Product Manager" }
  ],
  "Sports": [
    { staff_name: "Jillian Prunty", title: "Sports Editor" },
    { staff_name: "Arielle Rieder", title: "Sports Editor" },
    { staff_name: "Ashley Flores", title: "Deputy Sports Editor" },
    { staff_name: "Kaya Quebada", title: "Deputy Sports Editor" },
    { staff_name: "Emily Michaelsen", title: "Staff Writer" },
    { staff_name: "Benjamin Rubin", title: "Staff Writer" },
    { staff_name: "Holden Lombardo", title: "Staff Writer" },
    { staff_name: "Diane Lang", title: "Staff Writer" }
  ],
  "Copy": [
    { staff_name: "Posey Chiddix", title: "Head Copy Editor" },
    { staff_name: "Eli Trokenheim", title: "Deputy Copy Editor" },
    { staff_name: "Emily Spencer", title: "Deputy Copy Editor" },
    { staff_name: "Diego Carvajal Núñez", title: "Deputy Copy Editor" },
    { staff_name: "Reese Ransweiler", title: "Deputy Copy Editor" },
    { staff_name: "Vaishu Sirkay", title: "Deputy Copy Editor" },
    { staff_name: "Campbell Beaver", title: "Senior Associate Copy Editor" },
    { staff_name: "Claudia Kim", title: "Senior Associate Copy Editor" },
    { staff_name: "Daniel Knorek", title: "Senior Associate Copy Editor" },
    { staff_name: "Elizabeth Kushelevsky", title: "Senior Associate Copy Editor" },
    { staff_name: "Eric Aguilar", title: "Senior Associate Copy Editor" },
    { staff_name: "Georgia Bryan", title: "Senior Associate Copy Editor" },
    { staff_name: "Katharine Lee", title: "Senior Associate Copy Editor" },
    { staff_name: "Lily Lee", title: "Senior Associate Copy Editor" },
    { staff_name: "Megha Parikh", title: "Senior Associate Copy Editor" },
    { staff_name: "Althea Downing-Sherer", title: "Associate Copy Editor" },
    { staff_name: "Ames Yu", title: "Associate Copy Editor" },
    { staff_name: "Gigi Chen", title: "Associate Copy Editor" },
    { staff_name: "Natalie Wise", title: "Associate Copy Editor" },
    { staff_name: "Yoona Lee", title: "Associate Copy Editor" },
    { staff_name: "Dalina Cao", title: "Associate Copy Editor" },
    { staff_name: "Grace Mazer", title: "Associate Copy Editor" },
    { staff_name: "Kathleen Yang", title: "Associate Copy Editor" },
    { staff_name: "Maxwell Gaynor", title: "Associate Copy Editor" },
    { staff_name: "Sreya Gupta", title: "Associate Copy Editor" }
  ],
  "Illustrations": [
    { staff_name: "Conner Sund", title: "Illustrations Editor" },
    { staff_name: "Anaïs Fotsing", title: "Deputy Illustrations Editor" },
    { staff_name: "Ramona Delyser", title: "Deputy Illustrations Editor" },
    { staff_name: "Kelsea Petersen", title: "Senior Staff Illustrator" },
    { staff_name: "Sally Li Weitzner", title: "Staff Illustrator" },
    { staff_name: "Mila Petrolani", title: "Staff Illustrator" }
  ],
  "Spectrum": [
    { staff_name: "Manuela Moreyra", title: "Spectrum Editor" },
    { staff_name: "Loyca Jean", title: "Spectrum Deputy Editor" },
    { staff_name: "Isabella O'Connor", title: "Staff Writer" },
    { staff_name: "Ally Sepe", title: "Spectrum Deputy Editor" },
    { staff_name: "Terrah Garner", title: "Staff Writer" },
    { staff_name: "Suhani Arora", title: "Staff Writer" }
  ],
  "Arts and Culture": [
    { staff_name: "Taylor Graham", title: "Staff Writer" },
    { staff_name: "Ian Romero", title: "Staff Writer" },
    { staff_name: "Poppy Needham", title: "Staff Writer" },
    { staff_name: "Beatrice Moyers", title: "Deputy Editor" },
    { staff_name: "Nadia Knoblauch", title: "Staff Writer" }
  ],
  "Video": [
    { staff_name: "Elliot Heath", title: "Video Editor" },
    { staff_name: "Emily Huang", title: "Video Deputy Editor" },
    { staff_name: "Liz Backus", title: "Video Deputy Editor" },
    { staff_name: "Anna Strbka", title: "Video Deputy Editor" },
    { staff_name: "Ashlynne Graham", title: "Video Associate" },
    { staff_name: "Vi Tran", title: "Video Associate" },
    { staff_name: "Chris Perez", title: "Video Associate" }
  ],
  "Crosswords": [
    { staff_name: "Ananya Govindarajan", title: "Head of Crosswords" },
    { staff_name: "Molly Durawa", title: "Deputy Crosswords Editor" },
    { staff_name: "Reda Shaikh", title: "Crosswords" }
  ],
  "Opinion": [
  { staff_name: "Achilles Frangos", title: "Editorial Page Editor" },
  { staff_name: "Isabelle Bouvier", title: "Logistics Deputy" },
  { staff_name: "Ellessandra Taormino", title: "Columns Editor" },
  { staff_name: "Sydney Goldston", title: "Projects Deputy" },
  { staff_name: "Tommy Koh", title: "Projects Deputy" },
  { staff_name: "Sydney Alleyne", title: "Student Life Beat Editor" },
  { staff_name: "Cian Iacovou", title: "Admin/City Beat Editor" }
],
"University News": [
  { staff_name: "Isha Banerjee", title: "University News Editor" },
  { staff_name: "Apurva Chakravarthy", title: "Deputy News Editor" },
  { staff_name: "Daksha Pillai", title: "Deputy News Editor" },
  { staff_name: "Emily Pickering", title: "Deputy News Editor" },
  { staff_name: "Joseph Zuloaga", title: "Deputy News Editor" },
  { staff_name: "Spencer Davis", title: "Deputy News Editor" },
  { staff_name: "Tulasi Cherukuri", title: "Deputy News Editor" },
  { staff_name: "Eden Stranahan", title: "Senior Staff Writer" },
  { staff_name: "Grace Hamilton", title: "Senior Staff Writer" },
  { staff_name: "Ria Vashishtha", title: "Staff Writer" }
]

};
